import Admin, { hasRole, Role } from '@/models/Admin'
import Stock from '@/models/Stock'

export default class StockPolicy {
    viewAny(_admin: Admin): boolean {
        return true
    }

    view(admin: Admin, stock: Stock) {
        return false
    }

    create(admin: Admin) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.STATION_MANAGER, Role.STATION_OFFICER, Role.WAREHOUSE_MANAGER])
    }

    update(admin: Admin, stock: Stock) {
        return hasRole(admin, [Role.SUPER_ADMIN,Role.STATION_MANAGER, Role.STATION_OFFICER, Role.WAREHOUSE_MANAGER])
    }

    restore(admin: Admin, stock: Stock) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    delete(admin: Admin, stock: Stock) {
        return hasRole(admin, [Role.SUPER_ADMIN])
    }

    forceDelete(_admin: Admin, _stock: Stock) {
        return false
    }
}
